import {  SelectChangeEvent, Typography } from "@mui/material";
import ConfigWrapper from "../optionalFeatures/widget/ConfigWrapper";
import { CustomRadio, FeatureDropDown } from "../optionalFeatures/widget/FearturesInputTypes/FeatureInputs";
import { Input } from "@mantine/core";
import * as Sentry from "@sentry/react";
import * as countryModule from "countries-and-timezones";
import { objectKeys } from "../../../../utils/utils";
import { countryDialCodeMapping } from "../../../customerConfiguration/countryDialCodeMapping";
import { useEffect, useState } from "react";
import { DashboardToggleSwitch } from "../../../../components/Input/Input";
import QuestionHeading from "../../../../components/heading/QuestionHeading";
import { getLob } from "../../../../services/authenticationService";
const getSymbolFromCurrency = require("currency-symbol-map");
const countryToCurrency = require("country-to-currency");
interface Props{
    name:string,
    values:any,
setValues: React.Dispatch<React.SetStateAction<any>>;

}
 type HandleCountryCodeValueChangeParams = {
    keyName: string;
    countryValue: string;
  };

const ProjectConfigCustom=(props:Props)=>{
    const [uniqueCurrencies, setUniqueCurrencies] = useState<any[]>([]);
      const [clientTimeZoneOption, setClientTimeZoneOption] = useState<string[]>(
        []
      );
      const [clientDeployedCountry, setClientDeployedCountry] = useState<string>(
        localStorage.getItem("deploymentCountry") ?? ""
      );
      const [countryCodeOptions, setCountryCodeOptions] = useState<
        { title: string; value: string }[]
      >([]);
 
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let convertedVals: any;
        if (e.target.name === "supportNumber") {
          if (
            !/^\d*$/.test(e.target.value) ||
            e.target.value.length > 15 
    
          ) {
            return;
          }
        }
    
        if (e.target.name === "currencySymbol") {
          props.setValues({
            ...props.values,
            currencySymbol: {
              ...props.values["currencySymbol"],
              value: e.target.value,
              isValueUpdated: true,
              domainType: "customer_configuration",
            },
          });
        } else {
          const keyName = e.target.name;
          props.setValues({
            ...props.values,
            [keyName]: {
              ...props.values[keyName],
              value: e.target.value,
              isValueUpdated: true,
              domainType: "customer_configuration",
            },
          });
        }
      };
        const handleCountryCodeValueChange = (
    eOrCountryValue:
      | SelectChangeEvent<unknown>
      | HandleCountryCodeValueChangeParams
  ) => {
    let keyName: string;
    let countryValue: string;

    if ("target" in eOrCountryValue) {
      keyName = eOrCountryValue.target.name;
      countryValue = eOrCountryValue.target.value as string;
    } else {
      keyName = eOrCountryValue.keyName;
      countryValue = eOrCountryValue.countryValue;
    }

    const countryName = countryModule.getCountry(countryValue)?.name ?? "";
    const preFilledDialCode =
      countryDialCodeMapping[countryName]?.toString() ?? "";
    const currencyCode = countryToCurrency[countryValue];
    // // 
    const currencySymbol = getSymbolFromCurrency(currencyCode);
    setClientDeployedCountry(countryValue);
    props.setValues({
      ...props.values,
      [keyName]: {
        ...props.values[keyName],
        value: countryValue,
        isValueUpdated: true,
        domainType: "customer_configuration",
      },
      dialCode: {
        ...props.values["dialCode"],
        value: preFilledDialCode,
        isValueUpdated: true,
        domainType: "customer_configuration",
      },
      currency: {
        ...props.values["currency"],
        value: currencyCode,
        isValueUpdated: true,
        domainType: "customer_configuration",
      },
      currencySymbol: {
        ...props.values["currencySymbol"],
        value: currencySymbol,
        isValueUpdated: true,
        domainType: "customer_configuration",
      },
    });
  };
    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
    const keyName = e.target.name;
    if (keyName === "currency") {
      const currencySymbol = getSymbolFromCurrency(e.target.value);
      props.setValues({
        ...props.values,
        currencySymbol: {
          ...props.values["currencySymbol"],
          value: currencySymbol,
          isValueUpdated: true,
          domainType: "customer_configuration",
        },
        currency: {
          ...props.values["currency"],
          value: e.target.value,
          isValueUpdated: true,
          domainType: "customer_configuration",
        },
      });
    }else{
      props.setValues({
        ...props.values,
        [keyName]: {
          ...props.values[keyName],
          value: e.target.value,
          isValueUpdated: true,
          domainType: "customer_configuration",
        },
      });
    }
  };
      useEffect(() => {
          try {
            let countries = countryModule.getAllCountries();
            const keys = objectKeys(countries);
            const options = [] as { title: string; value: string }[];
            keys.forEach((key) => {
              options.push({ title: countries[key].name, value: countries[key].id });
              if (
                clientDeployedCountry !== "" &&
                clientDeployedCountry !== "{}" &&
                countries[key].name === clientDeployedCountry
              ) {
                setClientDeployedCountry(countries[key].id);
                handleCountryCodeValueChange({
                  keyName: "countryCode",
                  countryValue: countries[key].id,
                });
              }
            });
           setCountryCodeOptions(options);
          } catch (err) {
            Sentry.captureException(err);
          }
        }, []);
          useEffect(() => {
    const currencies = Array.from(new Set(Object.values(countryToCurrency)));
    setUniqueCurrencies(currencies);
    
  }, []);

  useEffect(() => {
      try {
        const timeZones = countryModule.getTimezonesForCountry(
          props.values?.countryCode?.value
        );
        if (timeZones?.length) {
          const timeZoneNames: string[] = timeZones.map((tZ) => tZ.name);
          setClientTimeZoneOption(timeZoneNames);
          props.setValues((prevValues:any) => ({
            ...prevValues,
            clientTimeZone: {
              ...prevValues.clientTimeZone,
              value: timeZoneNames[0],
              isValueUpdated: true,
              domainType: "customer_configuration",
            },
          }));
        }
      } catch (err) {
        Sentry.captureException(err);
      }
    }, [props.values?.countryCode]);


    return(
        <>
      
              <>
                <Typography sx={{fontWeight:"500",fontSize:"15px",color:"#000000"}} >
                  Select Country 
                </Typography>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <FeatureDropDown
                    onChange={handleCountryCodeValueChange}
                    placeholder="Country Code"
                    value={props.values?.countryCode?.value}
                    name="countryCode"
                    options={countryCodeOptions}
                    selectLableId="countryCode"
                    size="small"
                    width="100%"
                    height="95%"
                    // disabled={
                    //   clientDeployedCountry !== "" &&
                    //   clientDeployedCountry !== "{}"
                    // }
                    sx={{
                      minWidth: "50%",
                      marginTop: "0.5rem",
                      marginBottom: "1rem",
                     borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </div>

                <Typography sx={{fontWeight:"500",fontSize:"15px",color:"#000000"}}>Select Dial Code </Typography>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <FeatureDropDown
                    value={props.values?.dialCode?.value}
                    onChange={() => {}}
                    name="dialCode"
                    options={[props.values?.dialCode?.value]}
                    selectLableId="Dial Code"
                    disabled={true}
                    width="100%"
                    height="80%"
                    sx={{
                      minWidth: "50%",
                      marginTop: "0.5rem",
                      marginBottom: "1rem",
                     borderRadius: "8px",
                      padding: "10px",
                      display: "flex",
                    }}
                  />
                </div>

                <Typography sx={{fontWeight:"500",fontSize:"15px",color:"#000000"}}>Select Time Zone </Typography>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <FeatureDropDown
                    value={props.values?.clientTimeZone?.value}
                    onChange={handleSelectValueChange}
                    name="clientTimeZone"
                    options={clientTimeZoneOption}
                    selectLableId="Country Code"
                    width="100%"
                    height="80%"
                    sx={{
                      minWidth: "50%",
                      marginTop: "0.5rem",
                      marginBottom: "1rem",
                      borderRadius:"8px",
                      padding: "10px",
                    }}
                  />
                </div>
                <Typography sx={{fontWeight:"500",fontSize:"15px",color:"#000000"}}>Select the Currency</Typography>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <FeatureDropDown
                    value={props.values?.currency?.value}
                    onChange={handleSelectValueChange}
                    name="currency"
                    options={uniqueCurrencies}
                    selectLableId="Currency Code"
                    width="100%"
                    height="80%"
                    sx={{
                      minWidth: "50%",
                      marginTop: "0.5rem",
                      marginBottom: "1rem",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </div>
                <Typography sx={{fontWeight:"500",fontSize:"15px",color:"#000000"}}>
                  Enter Currency Symbol 
                </Typography>
                <Input
                  style={{
                    width: "100%",
                    display: "flex",
                    minWidth: "32%",
                    marginTop: "0.5rem",
                    marginBottom: "1rem",
                   
                  }}
       sx={{ 
      borderRadius: "8px",  
  }}

                  
                  name="currencySymbol"
                  value={props.values?.currencySymbol?.value}
                  onChange={handleValueChange}
                />
              
            
              </>
         
        </>
    )
}
export const ProjectDevelopedConfigurations=(props:Props)=>{
   const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
  const designations = currentUserData?.designation ?? [];
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let convertedVals: any;
 
        const keyName = e.target.name;
        props.setValues({
          ...props.values,
          [keyName]: {
            ...props.values[keyName],
            value: e.target.value,
            isValueUpdated: true,
            domainType: "customer_configuration",
          },
        });
      
    };
    const handleRadioChange = (e: SelectChangeEvent<unknown>,checked:boolean) => {
        const { name } = e.target;
        
        const newValue = checked ===true;
        props.setValues((prevValues:any) => ({
          ...prevValues,
          [name]: {
            ...prevValues[name],
            value: newValue,
            isValueUpdated: true,
            domainType: "customer_configuration",
          },
        }));
      };
  return(
    <>
    {designations.includes("admin") &&<ConfigWrapper
              heading="Developer Configurations"
              isCollapsable={true}
            >
              <>
              <Typography color={"#606060"}>
                  Enter deepLinkUrl :
                </Typography>
                <Input
                  style={{
                    width: "100%",
                    display: "flex",
                    minWidth: "32%",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                  styles={{
                    input: {
                      height: "2.9rem",
                    },
                  }}
                  name="externalAppDeepLink"
                  value={props.values?.externalAppDeepLink?.value}
                  onChange={handleValueChange}
                />
                 <Typography marginTop={2} color={"#606060"}>
              Enable ChatGpt
            </Typography>
            <div style={{ display: "flex", gap: "2vw" }}>
             <DashboardToggleSwitch
                   onChange={(e, checked) =>
    handleRadioChange(e,checked)
  }
                 checked={props.values?.chatGptEnabled?.value === true}
                  name="chatGptEnabled"
                 label={""}
             />
             
            </div>
              </>
            </ConfigWrapper>}
    </>
  )
}
export default ProjectConfigCustom
export const ProjectConfigCustomLob=()=>{
  return(
    <div style={{display:"flex",flexDirection:"column",gap:"8px",backgroundColor:"#f8fafc"}} >
      <div style={{fontWeight:"500",fontSize:"15px"}} >
        LOB Name
      </div>
      <input type="text" value={getLob()} disabled/>
    </div>
  )
}